import { AlertTriangle, Inbox, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { errMsg } from "@/lib/api";
import { UpgradeGate } from "@/components/common/UpgradeGate";

export const LoadingState = ({ rows = 3 }) => (
  <div className="space-y-3" data-testid="loading-state">
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} className="h-16 w-full rounded-xl" />
    ))}
  </div>
);

export const Spinner = ({ className = "" }) => <Loader2 className={`h-4 w-4 animate-spin ${className}`} />;

export const ErrorState = ({ error, onRetry }) => {
  if (error?.response?.status === 402) return <UpgradeGate message={errMsg(error)} />;
  return (
    <div className="rounded-xl border border-destructive/30 bg-destructive/5 p-6 text-center" data-testid="error-state">
      <AlertTriangle className="mx-auto mb-2 h-6 w-6 text-destructive" />
      <p className="text-sm text-foreground/90">{errMsg(error, "Não foi possível carregar os dados.")}</p>
      {onRetry && (
        <Button variant="outline" size="sm" className="mt-3" onClick={onRetry} data-testid="error-retry-btn">
          Tentar novamente
        </Button>
      )}
    </div>
  );
};

export const EmptyState = ({ icon: Icon = Inbox, title, description, action, testId = "empty-state" }) => (
  <div className="rounded-xl border border-dashed bg-card/50 px-6 py-12 text-center" data-testid={testId}>
    <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
      <Icon className="h-6 w-6" />
    </div>
    <h3 className="font-heading text-lg font-semibold">{title}</h3>
    {description && <p className="mx-auto mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
